import React from "react";
import { Paper, Typography, List, ListItem, ListItemText } from "@mui/material";
import { useTranslation } from "react-i18next";

const UserGuide = () => {
  const { t } = useTranslation();

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        {t("guideTitle")}
      </Typography>
      <Typography variant="body1" gutterBottom>
        {t("guideIntro")}
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        {t("guideSectionSetup")}
      </Typography>
      <List>
        <ListItem>
          <ListItemText primary={t("guideStepRegister")} />
        </ListItem>
        <ListItem>
          <ListItemText primary={t("guideStepVerifyEmail")} />
        </ListItem>
        <ListItem>
          <ListItemText primary={t("guideStepAssignDevice")} />
        </ListItem>
        <ListItem>
          <ListItemText primary={t("guideStepShareAccess")} />
        </ListItem>
      </List>
      <Typography variant="subtitle1" gutterBottom>
        {t("guideSectionSupport")}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t("guideSupportText")}
      </Typography>
    </Paper>
  );
};

export default UserGuide;
